import LayerKeys from './layerKeys'

export const CLICK_PRIORITY: Partial<Record<LayerKeys, number>> = {
  [LayerKeys.PRODUCTS]: 1,
  [LayerKeys.PRODUCTS_OVERHEAD]: 1,
  [LayerKeys.PRODUCTS_DIRECTIONAL]: 1,
  [LayerKeys.PRODUCTS_EVAP]: 1,
  [LayerKeys.PRODUCTS_HEATERS]: 1,
  [LayerKeys.DIMENSIONS]: 2, // TODO: rename variable as ANNOTATIONS for clarity
  [LayerKeys.UTILITY_BOXES]: 3,
  [LayerKeys.OBSTRUCTIONS]: 4,
  [LayerKeys.DOORS]: 5,
  [LayerKeys.COMFORT_ZONES]: 6,
  [LayerKeys.CEILINGS]: 7,
  [LayerKeys.ROOF_SECTIONS]: 8, // TODO: rename variable as MOUNTING_STRUCTURES for clarity
  [LayerKeys.ELEVATION_LINE]: 9,
  [LayerKeys.ELEVATION_POINT]: 9,
  [LayerKeys.ROOFS]: 9,
  [LayerKeys.INTERIOR_WALLS]: 10,
  [LayerKeys.EXTERIOR_WALLS]: 11,
  [LayerKeys.BACKGROUND_IMAGE]: 12,
}
